import { GENDER } from "../classes/enums/PatientInfoEnum";
import { dbDateFormat } from "../classes/utils/DateUtils";

export const standardizeGender = gender => {
  if (!gender) return null;

  const lowerGender = gender.toLowerCase();
  if (lowerGender === "male" || lowerGender === "m") {
    return GENDER.MALE;
  } else if (lowerGender === "female" || lowerGender === "f") {
    return GENDER.FEMALE;
  }

  return null;
};

/**
 * Formats a filename for morphology images according to the pattern:
 * Originalname_modality_orientation_date_currentdate
 *
 * @param {string} originalFilename - The original filename
 * @param {string} modality - The image modality (e.g., MO, DX, CT)
 * @param {string} orientation - The image orientation
 * @param {Date|string|number} acquisitionDate - The date the image was acquired
 * @returns {string} The formatted filename
 */
export const formatMorphologyFilename = (
  originalFilename,
  modality,
  orientation,
  acquisitionDate
) => {
  // Remove file extension to get the base name
  const baseNameMatch = originalFilename.match(/(.+)(\.[^.]+)$/);
  const baseName = baseNameMatch ? baseNameMatch[1] : originalFilename;
  const extension = baseNameMatch ? baseNameMatch[2] : "";

  // Format the acquisition date (ensuring it's in YYYYMMDD format)
  const formattedAcquisitionDate = acquisitionDate
    ? dbDateFormat(acquisitionDate)
    : "unknown";

  // Get current date in YYYYMMDD format
  const today = new Date();
  const currentDate = dbDateFormat(today);

  // Format orientation to be more filename-friendly (remove spaces, arrows, etc.)
  const safeOrientation = orientation
    ? orientation.replace(/\s+/g, "").replace(/[→→]/g, "to")
    : "unknown";

  // Construct the new filename
  return `${baseName}_${
    modality || "unknown"
  }_${safeOrientation}_${formattedAcquisitionDate}_${currentDate}${extension}`;
};
